/* eslint-disable import/no-cycle */
import _ from 'lodash';
import api from '~/services';
import log from '~/helpers/log';
import {
  verifyIfLetterExist,
  normalizeContactObjects,
} from '~/helpers/contactListFormat';
import { lastCheckContacts } from './index';
import * as actionTypes from './actionTypes';

// export const addNewContacts = (id, type = 'All') => async (
//   dispatch,
//   getState
// ) => {
//   const { contact } = getState();
//   const { dataAll, dataPersonal } = contact;
//   const data = type === 'All' ? dataAll : dataPersonal;

//   try {
//     const response = await api.contacts.get.contactInfo(id);
//     const all = data.reduce((prev, next) => prev.concat(next.data), []);
//     const normalized = normalizeContactObjects(response.data);
//     const result = all;
//     result.unshift(normalized);
//     const newArray = result.map(e => {
//       const letter = verifyIfLetterExist(e.name[0].toLowerCase());

//       return {
//         ...e,
//         name: `${e.name}`,
//         letter,
//       };
//     });

//     const saveContacts = _(newArray)
//       .orderBy(o => o.letter)
//       .groupBy(o => o.letter)
//       .map((e, letter) => ({ title: letter, data: e }))
//       .value();

//     dispatch({
//       type: actionTypes.CONTACTS_UPDATE,
//       payload: {
//         [type === 'All' ? 'dataAll' : 'dataPersonal']: saveContacts,
//         type,
//         loading: false,
//       },
//     });
//   } catch (err) {
//     log.error(err);
//   }
// };

export const deleteContact = (type = 'Personal', id) => async (
  dispatch,
  getState
) => {
  const { contact } = getState();
  const { dataAll, dataPersonal } = contact;
  const data = type === 'All' ? dataAll : dataPersonal;
  const all = data.reduce((prev, next) => prev.concat(next.data), []);

  try {
    const newArray = all
      .filter(e => e.id !== id)
      .map(e => {
        const letter = verifyIfLetterExist(e.name[0].toLowerCase());

        return {
          ...e,
          name: `${e.name}`,
          letter,
        };
      });

    const saveContacts = _(newArray)
      .orderBy(o => o.letter)
      .groupBy(o => o.letter)
      .map((e, letter) => ({ title: letter, data: e }))
      .value();

    dispatch({
      type: actionTypes.CONTACTS_UPDATE,
      payload: {
        [type === 'All' ? 'dataAll' : 'dataPersonal']: saveContacts,
        type,
        loading: false,
      },
    });
  } catch (err) {
    log.error('Failed to delete contact.', err);
  }
};

export const checkNewContacts = (
  type = 'All',
  newContact = false,
  updateContact = false,
  id
) => async (dispatch, getState) => {
  const { contact, system, auth } = getState();
  const { dataAll, dataPersonal } = contact;

  const data = type === 'All' ? dataAll : dataPersonal;
  let response;
  let dataContacts = null;

  try {
    if (!newContact) {
      if (!updateContact) {
        response = await api.contacts.get.checkUpdates(
          system.lastRequestedContacts,
          type !== 'All'
        );
        dataContacts =
          type === 'All'
            ? response.data._embedded
            : response.data._embedded.filter(
                e => e.deleted === 'true' || e.owner_id === auth.userIdCode
              );
      } else {
        response = await api.contacts.get.contactInfo(id);
        dataContacts = [response.data];
      }

      if (dataContacts.length > 0) {
        const all = data.reduce((prev, next) => prev.concat(next.data), []);

        // remove contact to local list
        dataContacts.forEach(ee => {
          const f = all.find(elem => elem.id === ee.id);

          if (typeof f === 'undefined') {
            const letter = verifyIfLetterExist(
              ee.first_name[0] ? ee.first_name[0].toLowerCase() : '#'
            );
            const normalized = normalizeContactObjects(ee, letter);
            all.push(normalized);
          }
        });

        // check contact updated
        const result = all.map(el => {
          const found = dataContacts.find(s => s.id === el.id);
          if (found) {
            const letter = verifyIfLetterExist(
              found.first_name[0] ? found.first_name[0].toLowerCase() : '#'
            );
            const normalized = normalizeContactObjects(found, letter);
            return normalized;
          }
          return el;
        });

        const newArray = _.orderBy(result, o => o.name.toLowerCase(), ['asc'])
          .filter(e => e.deleted !== 'true')
          .map(e => {
            const letter = verifyIfLetterExist(e.name[0].toLowerCase());

            return {
              ...e,
              name: `${e.name}`,
              letter,
            };
          });

        const saveContacts = _(newArray)
          .orderBy(o => o.letter)
          .groupBy(o => o.letter)
          .map((e, letter) => ({ title: letter, data: e }))
          .value();

        dispatch({
          type: actionTypes.CONTACTS_UPDATE,
          payload: {
            [type === 'All' ? 'dataAll' : 'dataPersonal']: saveContacts,
            type,
            loading: false,
          },
        });
      }
      dispatch(lastCheckContacts(response.data?.requested_at));
    }
  } catch (err) {
    dispatch({
      type: actionTypes.CONTACTS_FAILURE,
      payload: {
        message: err.message,
        loading: false,
      },
    });
  }
};

export const getContacts = (type = 'All') => async dispatch => {
  dispatch({
    type: actionTypes.CONTACTS_STORE,
    payload: {
      loading: true,
    },
  });
  try {
    let response = null;

    const resp = await api.contacts.get.list(type, 1);
    const totalItems = resp.data.total_items;
    const pageSize = resp.data.page_size;
    const totalPages = Math.ceil(
      parseInt(totalItems, 10) / parseInt(pageSize, 10)
    );
    response = resp.data._embedded;
    // eslint-disable-next-line no-plusplus
    for (let i = 2; i <= totalPages; i++) {
      // eslint-disable-next-line no-await-in-loop
      const newData = await (await api.contacts.get.list(type, i)).data
        ._embedded;
      response = [...response, ...newData];
    }

    // eslint-disable-next-line no-underscore-dangle
    const newArray = response.map(e => {
      if (typeof e.first_name[0] === 'undefined') {
        e.first_name = 'Undefined';
      }
      const letter = verifyIfLetterExist(e.first_name[0]);
      return normalizeContactObjects(e, letter);
    });

    const saveContacts = _(newArray)
      .orderBy(o => o.letter)
      .groupBy(o => o.letter)
      .map((data, letter) => ({ title: letter, data }))
      .value();

    dispatch({
      type: actionTypes.CONTACTS_SUCCESS,
      payload: {
        [type === 'All' ? 'dataAll' : 'dataPersonal']: saveContacts,
        type,
        loading: false,
      },
    });
    dispatch(lastCheckContacts(resp.data?.requested_at));
  } catch (err) {
    dispatch({
      type: actionTypes.CONTACTS_FAILURE,
      payload: {
        message: err.message,
        loading: false,
      },
    });
  }
};

export const resetContacts = () => dispatch => {
  dispatch({
    type: actionTypes.CONTACTS_RESET,
  });
};

export const setOrganizationsAndGroups = () => async dispatch => {
  try {
    const org = await api.contacts.organization.list();
    const groups = await (await api.contacts.groups.list()).data._embedded;
    const groupList = groups.map(item => {
      return {
        group_id: parseInt(item.group_id, 10),
        group_name: item.group_name,
      };
    });

    dispatch({
      type: actionTypes.CONTACT_SET_ORG_GROUPS,
      payload: {
        organizations: org.data,
        groups: groupList,
      },
    });
  } catch (err) {
    log.error('Failed to set organizations and groups.', err);
  }
};

export const createOrganization = ({ name }) => async (dispatch, getState) => {
  if (name) {
    const newOrg = await api.contacts.organization.create({ name });
    const newOrgList = await api.contacts.organization.list();
    const { groups } = getState().contact;

    dispatch({
      type: actionTypes.CONTACT_SET_ORG_GROUPS,
      payload: {
        organizations: newOrgList.data,
        groups,
      },
    });

    return newOrg.data;
  }

  return null;
};

export const createGroups = ({ name }) => async (dispatch, getState) => {
  if (name) {
    const group = await api.contacts.groups.create({ name });
    const groups = await api.contacts.groups.list();
    const { organizations } = getState().contact;
    const groupList = groups.data._embedded.map(item => {
      return {
        group_id: parseInt(item.group_id, 10),
        group_name: item.group_name,
      };
    });

    dispatch({
      type: actionTypes.CONTACT_SET_ORG_GROUPS,
      payload: {
        organizations,
        groups: groupList,
      },
    });

    return group.data;
  }

  return null;
};
